
    export default 
    {
    "top_stores": {
        "store_authorized_tip": "Il negozio necessita di una nuova autorizzazione. Vai su Impostazioni - Account per aggiornare l'autorizzazione. Altrimenti non puoi far funzionare correttamente il negozio con DSers"
    }
}